import { render, staticRenderFns } from "./ApprovalVideo.vue?vue&type=template&id=e7f24a0c&"
import script from "./ApprovalVideo.vue?vue&type=script&lang=js&"
export * from "./ApprovalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports